export const isAppLoadingSelector = (state) => state.app.isLoading;
export const guestPortalAuthFlowSelector = (state) => state.app.guestPortalAuthFlow;
export const guestPortalIdSelector = (state) => state.app.guestPortalId;
export const showMobileInfoSelector = (state) => state.app.showMobileInfo;
